const MIN_COUNT = 2;
const CHECKBOX_MIN_COUNT = 1;

const getMinCountOfOptionsFieldControl = (type, fieldTypes) =>
  type === fieldTypes.checkbox ? CHECKBOX_MIN_COUNT : MIN_COUNT;

const getOptionsFieldControlDefaultValue = (type, fieldTypes) => {
  const minCount = getMinCountOfOptionsFieldControl(type, fieldTypes);

  return [...Array(minCount).keys()].map(() => ({ option: '' }));
};

export default getOptionsFieldControlDefaultValue;
export { getMinCountOfOptionsFieldControl };
